var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors.length > 0)?_c('div',{staticClass:"overlay"},_vm._l((_vm.errors),function(error){return _c('div',{key:error.id,staticClass:"error"},[_vm._v("\n        "+_vm._s(error)+"\n        "),_c('span',{staticClass:"fa fa-close",on:{"click":function($event){return _vm.closeError()}}})])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }